import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { handleLoginSuccess, logoutUser, uiError } from '../../actions';
import { firebasePostApi } from '../../api/firebaseApi';
import LoadingIndicator from '../../components/base/loadingIndicator/LoadingIndicator';
import { getRedirectPathFromFeatureType } from '../signup/helper';

const SignIn = ({ logoutUserAction }) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'loginAndSignup',
  });

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const accessToken = searchParams.get('code');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleErrorMessage = useCallback(() => {
    dispatch(uiError({ isError: true, message: t('invalidMagicLinkToken') }));
  }, [dispatch, t]);

  const handleSuccessMessage = useCallback(() => {
    dispatch(uiError({ isError: false, message: null }));
  }, [dispatch]);

  useEffect(() => {
    const verifyMagicLinkToken = async () => {
      try {
        handleSuccessMessage();
        const response = await firebasePostApi('/user/sign-in/token', {
          accessToken,
        });

        if (response?.customToken) {
          await logoutUserAction();
          await firebase
            .auth()
            .signInWithCustomToken(response.customToken)
            .then(() => handleLoginSuccess('password-free'))
            .catch(() => handleErrorMessage());
        } else {
          handleErrorMessage();
        }
        if (response?.redirectFeature) {
          navigate(getRedirectPathFromFeatureType(response.redirectFeature));
        } else {
          navigate('/');
        }
      } catch (_error) {
        handleErrorMessage();
        navigate('/');
      }
    };
    if (!accessToken) {
      navigate('/');
    } else {
      verifyMagicLinkToken().then();
    }
  }, [
    dispatch,
    handleErrorMessage,
    navigate,
    accessToken,
    logoutUserAction,
    handleSuccessMessage,
  ]);

  return <LoadingIndicator positionAbsoluteCenter size={42} />;
};

SignIn.propTypes = {
  logoutUserAction: PropTypes.func.isRequired,
};

export default connect(null, {
  logoutUserAction: logoutUser,
})(SignIn);
